/**
 * 环境名
 */
enum Env {
  // 开发
  Development = 'development',
  // 生产
  Production = 'production',
  // 线上开发联调(不是本地开发环境)
  Dev = 'dev',
  // 测试
  Qa = 'qa',
  // 预发布
  Pre = 'pre',
}

export default Env;
